<template>
    <div id="login" :style="'background:url('+backImg+');background-size: 100% 100%;'">
        <div class="box">
            <p class="info">注册</p>
            <el-form :model="form" class="form">
                <el-form-item>
                    <el-input v-model="form.tel" placeholder="请输入手机号">
                        <i slot="prefix" class="el-input__icon el-icon-mobile"></i>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="form.QQ" placeholder="请输入QQ号">
                        <i slot="prefix" class="el-input__icon el-icon-user"></i>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="form.password" placeholder="请输入密码" type="password">
                        <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="form.password_confirm" placeholder="确认密码" type="password">
                        <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                    </el-input>
                </el-form-item>
                <!-- <el-form-item>
                    <el-input v-model="form.invitecode" placeholder="邀请码">
                        <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                    </el-input>
                </el-form-item> -->
                <el-form-item>
                    <el-input v-model="form.code" placeholder="请输入手机验证码">
                        <i slot="prefix" class="el-input__icon el-icon-postcard"></i>
                        <template slot="append">
                            <el-button style="background-color: #409eff;color: white;" @click="getCode" type="primary">{{getText}}</el-button>
                        </template>
                    </el-input>
                </el-form-item>
            </el-form>
            <el-button type="primary" style="width:200px" @click="registerIt">注册</el-button>
            <!-- <p v-if="!is_share" class="forget " @click="toLogin">登录</p> -->
			<!-- v-if="!is_share" -->
			<div style="font-size:30px;margin-top: 15px;background-color: #fff;color: red;width: 100%;height: 50px;line-height: 50px;padding: 0 20px;box-sizing: border-box;">收不到验证码联系客服</div>
			<el-button  class="forget " type="primary" style="width:200px" @click="toLogin">登录</el-button>
        </div>
    </div>
</template>

<script>
import { getcode, register, getback } from '@/api/login'
export default {
    name: "loginIn",
    data() {
        return {
            form: {
                tel: '',
                QQ: '',
                password: '',
                password_confirm: '',
                invitecode: '',
                code: ''
            },
            getText: '获取验证码',
            totalTime: 60,
            buyer_id: '',
            is_share: false,
            backImg: '',
            agent: ''
        }
    },
    created() {
        let buyer_id = this.$route.query.buyer_id
        let agent = this.$route.query.agent
        if (buyer_id) {
            this.buyer_id = buyer_id
            this.is_share = true
        }
        if (agent) {
            this.agent = agent
        }
        this.getBackImg()
    },
    methods: {
        getBackImg() {
            getback().then(res => {
                this.backImg = res.data.shop_theme_background
            })
        },
        getCode() {
            var myreg = /^[1][2,3,4,5,6,6,7,8,9][0-9]{9}$/;
            if (!myreg.test(this.form.tel)) {
                this.$message({
                    message: '手机号格式不正确',
                    type: "error",
                });
                return false;
            }
            getcode({
                mobile: this.form.tel,
                event: 'register',
                type: 1,
            }).then(res => {
                if (res.code == 1) {
                    this.$message({
                        message: '发送成功',
                        type: "success",
                    });
                    this.haveCode()
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error",
                    });
                }
            })

        },
        haveCode() {
            if (this.getText == '重新发送验证码' || this.getText == '获取验证码') {
                // this.countDown = true;//点击之后设置按钮不可取
                this.getText = this.totalTime + "s后重新发送";//按钮内文本
                let clock = window.setInterval(() => {
                    this.totalTime--;
                    this.getText = this.totalTime + "s后重新发送";
                    if (this.totalTime < 0) {
                        window.clearInterval(clock);
                        this.getText = "重新发送验证码";
                        this.totalTime = 60;
                        this.countDown = false; //这里重新开启
                    }
                }, 1000);
            }
        },
        toLogin() {
            this.$router.push({
                name: 'login',
            })
        },
        registerIt() {
            let data = {
                mobile: this.form.tel,
                qq_num: this.form.QQ,
                password: this.form.password,
                password_confirm: this.form.password_confirm,
                invitecode: this.buyer_id ? this.buyer_id : '',
                code: this.form.code,
                agent: this.agent ? this.agent : ''
            }
            register(data).then(res => {
                if (res.code == 1) {
                    this.$message({
                        message: '注册成功',
                        type: "success",
                    });
                    this.$store.commit("changeLogin", res.data.token);
                    this.$router.push({
                        name: 'report'
                    })
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error",
                    });
                }
            })
        },
    }
};
</script>

<style lang="scss" scoped>
#login {
    width: 100%;
    height: 100vh;
    background-size: 100% 100%;
    position: relative;
    .box {
        width: 450px;
        height: 600px;
        border-radius: 20px;
        background: rgba(0, 0, 0, 0.5);
        text-align: left;
        padding: 30px;
        color: white;
        position: absolute;
        right: 10%;
        bottom: 20%;
        .title {
            font-size: 35px;
        }
        .info {
            font-size: 18px;
            margin-top: 20px;
        }
        .form {
            margin-top: 20px;
        }
        .forget {
            color: white;
            font-size: 13px;
            position: absolute;
            left: 30px;
            bottom: 30px;
            cursor: pointer;
        }
    }
}
</style>
